import { IBookMark } from '#/types/bookmark';
import { BookMarksActionType, TBookMarksActions } from '../actions/bookmarks';

interface IState {
  bookmarks: IBookMark[];
  loading: boolean;
}

const initialState: IState = {
  bookmarks: [],
  loading: false,
};

const bookmarksReducer = (
  state = initialState,
  action: TBookMarksActions
): IState => {
  switch (action.type) {
    case BookMarksActionType.BOOKMARKS_ADD_BOOKMARK:
      return { ...state, bookmarks: [...state.bookmarks, action.payload] };

    case BookMarksActionType.BOOKMARKS_REMOVE_BOOKMARK:
      return {
        ...state,
        bookmarks: state.bookmarks.filter(
          (bookmark) =>
            !(
              bookmark.type === action.payload.type &&
              bookmark.id === action.payload.id
            )
        ),
      };

    case BookMarksActionType.BOOKMARKS_REMOVE_ALL_BOOKMARKS:
      return {
        ...state,
        bookmarks: [],
      };

    case BookMarksActionType.BOOKMARKS_START_LOADING:
      return {
        ...state,
        loading: true,
      };

    case BookMarksActionType.BOOKMARKS_STOP_LOADING:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default bookmarksReducer;
